/**
 * returns true if global variable parmonic_disable_analytics is set to true
 *
 */
export default function (): boolean {
  //If variable is set use variable value
  if (window.parmonic_disable_analytics) return window.parmonic_disable_analytics
  return false
}
